import { BlogTheme } from "@types"

import { ThemeColor, THEME_COLORS } from "@types"

import { Inter, Spectral, Roboto_Mono } from "next/font/google"

/**
 * These are the possible fonts for a blog.
 */
const inter = Inter({
  subsets: ["latin"],
  variable: "--font-inter",
})

const spectral = Spectral({
  subsets: ["latin"],
  variable: "--font-spectral",
  weight: ["300", "400", "500", "600", "700", "800"],
})

const robotoMono = Roboto_Mono({
  subsets: ["latin"],
  variable: "--font-roboto-mono",
})

/**
 * Re-export these here to explicitly
 * keep all theming logic in this file.
 */
export { THEME_COLORS }
export type { ThemeColor }

/**
 * Helper function to get the class name and styles
 * for the colors and fonts for a blog.
 *
 * The actual CSS colors and fonts are listed in app/theme.scss.
 */
export function getBlogTheme(theme?: BlogTheme) {
  const fonts: { [key: string]: string } = {
    sans: inter.variable,
    serif: spectral.variable,
    mono: robotoMono.variable,
  }

  const headerFont = theme?.headerFont || "sans"
  const bodyFont = theme?.bodyFont || "sans"

  const blogThemeColor = theme?.color || "default"
  const blogThemeHeaderFont = fonts[headerFont]
  const blogThemeBodyFont = fonts[bodyFont]

  return `paragraph-custom-theme paragraph-color-${blogThemeColor} header-font-${headerFont} body-font-${bodyFont} ${blogThemeHeaderFont} ${blogThemeBodyFont}`
}
